import React from "react";

const IconBuilding = (props) => {
  return (
    <svg
      width={props.width || "22"}
      height={props.height || "22"}
      viewBox="0 0 17.162 17.14"
      {...props}
    >
      <g
        id="Group_2809"
        dataname="Group 2809"
        transform="translate(603.92 -223.425)"
      >
        <path
          id="Path_10020"
          dataname="Path 10020"
          d="M-596.493,240.065h-4.4v-9.649a.847.847,0,0,1,.847-.847h3.55"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeWidth="1"
        />
        <path
          id="Rectangle_5909"
          dataname="Rectangle 5909"
          d="M.847,0H6.035a.847.847,0,0,1,.847.847V16.14a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.847A.847.847,0,0,1,.847,0Z"
          transform="translate(-596.493 223.925)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeWidth="1"
        />
        <line
          id="Line_195"
          dataname="Line 195"
          x2="1.471"
          transform="translate(-593.523 227.396)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_196"
          dataname="Line 196"
          x2="1.471"
          transform="translate(-593.523 231.513)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_197"
          dataname="Line 197"
          x2="1.471"
          transform="translate(-593.523 235.631)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_198"
          dataname="Line 198"
          x2="1.471"
          transform="translate(-598.405 232.758)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_199"
          dataname="Line 199"
          x2="1.471"
          transform="translate(-598.405 236.876)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_200"
          dataname="Line 200"
          x2="16.162"
          transform="translate(-603.42 240.065)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconBuilding;
